import { getStore } from "../store/Store";
import isMailComposeActiveWithReadingPaneOff from "./isMailComposeActiveWithReadingPaneOff";

/**
 * Returns a flag indicating whether to show reading pane or not
 */
export function shouldShowReadingPane(): boolean {
    return isMailComposeActiveWithReadingPaneOff() || getStore().showReadingPane;
}
